import React, { useEffect, useState } from "react";
import "../Css/groove_pdf.css";
import { Modal } from "react-bootstrap";
import BarLoader from "react-spinners/BarLoader";
import WiPdfMain from "./WiPdfMain";
import html2pdf from 'html2pdf.js';
import WiPdfTubeToTubesheet1 from "./WiPdfTubeToTubesheet1";
import WiPdfTubeToTubesheet2Hindi from "./WiPdfTubeToTubesheet2Hindi";
import WiPdfTubeToTubesheet3Hindi from "./WiPdfTubeToTubesheet3Hindi";
import WiPdf3Hindi from "./WiPdf3Hindi";
import WiPdf2Hindi from "./WiPdf2Hindi";
import WiPdfViewer from "./WiPdfViewer";

const WiPdfDownload = (props) => {
  const { mode = 'download' } = props;
  const [showSuccessModel] = useState(false);
  const [showForm] = useState(false);
  const [showConfirmModel] = useState(false);
  const [loading, setLoading] = useState(true);
  
  const downloadPdf = () => {
    setLoading(true);
    const element = document.querySelector('#MainDiv');
    const options = {
      filename: `WI Report ${props?.rowdata[1]?.wld_WPSType}`,
      margin: [0, 0.5, 0, 0],
      html2canvas: { scale: 3 },
      jsPDF: { unit: 'in', format: "A4", orientation: 'portrait', compressPDF: true },
    };
    html2pdf().set(options).from(element).save();
    props.onHide();
    props.setReload(!props.reload);
    setLoading(false)
  }

  useEffect(() => {
    if (mode === 'download') {
      downloadPdf();
    }
  }, [props?.rowdata]);
  
  // If mode is 'view', use the viewer component
  if (mode === 'view') {
    return <WiPdfViewer {...props} />;
  }

  return (
    <>
      <Modal
        {...props}
        size="sm"
        centered
        transparent={true}
        className={
          showForm || showSuccessModel || showConfirmModel
            ? "opacity-0 userMasterModal"
            : "opacity-100 userMasterModal"
        }
        backdrop="static"
      >
        <Modal.Body
          style={{
            maxHeight: "calc(1000vh - 1000px)",
          }}
        >
          <p>
            {loading && (
              <BarLoader
                color="blue"
                height={8}
                width={196}
                className="shift"
              />
            )}
          </p>
        </Modal.Body>
      </Modal>
      <div id="MainDiv">
        <br></br>
        {props?.rowdata[1].wld_WPSType !== "Tubesheet" ?
          <>
            <WiPdfMain
              rowdata={props?.rowdata}
              wpsde={props.wpsde}
            />
            <div style={{ pageBreakInside: "avoid", paddingTop: "30px" }}>
              <WiPdf2Hindi
                rowdata={props?.rowdata}
                wpsde={props.wpsde}
              />
            </div>
            <div style={{ pageBreakInside: "avoid", paddingTop: "30px" }}>
              <WiPdf3Hindi
                rowdata={props?.rowdata}
                wpsde={props.wpsde}
              />
            </div>
          </>
          :
          <>
            <WiPdfTubeToTubesheet1
              rowdata={props?.rowdata}
              wpsde={props.wpsde}
            />
            <div style={{ pageBreakInside: "avoid", paddingTop: "30px" }}>
              <WiPdfTubeToTubesheet2Hindi
                rowdata={props?.rowdata}
                wpsde={props.wpsde}
              />
            </div>
            <div style={{ pageBreakInside: "avoid", paddingTop: "30px" }}>
              <WiPdfTubeToTubesheet3Hindi
                rowdata={props?.rowdata}
                wpsde={props.wpsde}
              />
            </div>
          </>
        }
      </div>
    </>
  )
}

export default WiPdfDownload;